import { render, staticRenderFns } from "./seckill_fuw.vue?vue&type=template&id=3adcf2e5&scoped=true&"
import script from "./seckill_fuw.vue?vue&type=script&lang=js&"
export * from "./seckill_fuw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3adcf2e5",
  null
  
)

export default component.exports